var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('data-section',{attrs:{"theme":"green","title":"國泰產險-火險","isFireInsurance":true,"datas":_vm._.orderBy(
      _vm.highlightModify,
      ['familyrl', 'age', 'ceisdno', 'orderbBySelf', 'ceplcno'],
      ['asc', 'desc', 'asc', 'asc', 'asc']
    ),"_fields":[
      {
        name: '保單號碼',
        key: 'ceplcno',
        width: 145,
        sortable: true,
        orderByMultiKey: ['ceplcno'],
        orderByMultiType: ['asc']
      },
      {
        name: '險種',
        key: 'cepln_nm',
        width: 188,
        sortable: true,
        orderByMultiKey: ['cepln_nm'],
        orderByMultiType: ['asc']
      },
      {
        name: '被保人',
        key: 'ceisdnm',
        width: 94,
        sortable: true,
        className: 'link text-underline',
        orderByMultiKey: ['ceisdnm'],
        orderByMultiType: ['asc']
      },
      {
        name: '有效期間',
        key: 'celpsdt',
        width: 140,
        sortable: true,
        orderByMultiKey: ['celpsdt'],
        orderByMultiType: ['asc']
      },
      {
        name: '主險保費',
        key: 'premium1',
        width: 83,
        sortable: true,
        className: 'text-right',
        orderByMultiKey: ['premium1'],
        orderByMultiType: ['asc']
      },
      {
        name: '附加險總保費',
        key: 'add_prem',
        width: 109,
        sortable: true,
        className: 'text-right',
        orderByMultiKey: ['add_prem'],
        orderByMultiType: ['asc']
      },
      {
        name: '標的地址',
        key: 'address',
        width: 179,
        sortable: true,
        orderByMultiKey: ['address'],
        orderByMultiType: ['asc']
      }
    ].concat(_vm._fields),"initShow":_vm.$route.query['CathayPropertyFireInsuranceShow'] !== 'false'},on:{"toggle":function (isShow) { return _vm.$router.assignQuery({ CathayPropertyFireInsuranceShow: isShow }); }},scopedSlots:_vm._u([{key:"default",fn:function(props){return _vm.refresh?[_c('data-table',_vm._b({attrs:{"initSort":_vm.$route.query["CathayPropertyFireInsuranceSort"]
          ? JSON.parse(_vm.$route.query["CathayPropertyFireInsuranceSort"])
          : null},on:{"changeSort":function (sort) {
              var _obj;

              return _vm.$router.assignQuery(( _obj = {}, _obj["CathayPropertyFireInsuranceSort"] = JSON.stringify(sort), _obj ));
      }},scopedSlots:_vm._u([{key:"ceplcno",fn:function(item){return [_c('span',{class:{ 'text-blue': item.data.isKeyinBySelf }},[_vm._v(_vm._s(item.data.ceplcno))])]}},{key:"celpsdt",fn:function(item){return [_c('div',{staticClass:"pre-formatted",domProps:{"innerHTML":_vm._s(
            _vm.buildStartEndWithTimeString(
              _vm.getROCDate(item.data.ceplcdt),
              _vm.getROCDate(item.data.celpsdt),
              item.data.ceplcdt_time,
              item.data.celpsdt_time
            )
          )}})]}},{key:"ceisdnm",fn:function(item){return [_c('span',{on:{"click":function($event){_vm.routeToCustDetail(item.data.ceisdno , item.data.ceisdnm)}}},[_vm._v("\n          "+_vm._s(_vm._f("truncate")(item.data.ceisdnm))+"\n        ")])]}},{key:"premium1",fn:function(item){return [_vm._v(_vm._s(_vm._f("numberFormat")(item.data.premium1))+"元")]}},{key:"add_prem",fn:function(item){return [_vm._v(_vm._s(_vm._f("numberFormat")(item.data.add_prem))+"元")]}},{key:"action",fn:function(item){return [_c('a',{staticClass:"text-red text-underline",attrs:{"role":"button"},on:{"click":function($event){_vm.doDelete(item.data)}}},[_vm._v("刪除")])]}}])},'data-table',props,false))]:undefined}}])})}
var staticRenderFns = []

export { render, staticRenderFns }